/* Side Cart Drawer — standalone Dawn integration, no external dependencies. */



(() => {



  if (window.__sideCartDrawerScriptLoaded) return;



  window.__sideCartDrawerScriptLoaded = true;







  const cartRoute = (action) => {



    const configured = window.routes?.[`cart_${action}_url`];



    if (configured) {



      const [path, query] = configured.split('?');



      return `${/\.(js|json)$/.test(path) ? path : `${path}.js`}${query ? `?${query}` : ''}`;



    }



    const root = window.Shopify?.routes?.root || '/';



    return `${root.endsWith('/') ? root : `${root}/`}cart/${action}.js`;



  };



  const cartJsonRoute = () => {



    const root = window.Shopify?.routes?.root || '/';



    return `${root.endsWith('/') ? root : `${root}/`}cart.js`;



  };



  const sameCode = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();







  class SideCartDrawer extends HTMLElement {



    constructor() {



      super();



      this.onClick = this.onClick.bind(this);



      this.onChange = this.onChange.bind(this);



      this.onSubmit = this.onSubmit.bind(this);



      this.onDocumentClick = this.onDocumentClick.bind(this);



      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);



      this.onSectionUnload = this.onSectionUnload.bind(this);



      this.onSectionSelect = this.onSectionSelect.bind(this);



      this.onSectionDeselect = this.onSectionDeselect.bind(this);



      this.onBlockSelect = this.onBlockSelect.bind(this);



    }







    connectedCallback() {



      // Sticky headers can transform their descendants, which breaks fixed drawers.



      if (this.parentElement !== document.body) {



        document.querySelectorAll('body > cart-drawer[data-side-cart-root]').forEach((old) => {



          if (old !== this) old.remove();



        });



        document.body.appendChild(this);



        return;



      }



      if (this._connected) return;



      this._connected = true;



      this.setAttribute('aria-hidden', this.classList.contains('active') ? 'false' : 'true');

    window.dispatchEvent(new CustomEvent('sidecart:ready', { detail: { drawer: this } }));



      this.addEventListener('click', this.onClick);



      this.addEventListener('change', this.onChange);



      this.addEventListener('submit', this.onSubmit);



      document.addEventListener('click', this.onDocumentClick);



      document.addEventListener('keydown', this.onDocumentKeydown, true);



      document.addEventListener('shopify:section:unload', this.onSectionUnload);



      document.addEventListener('shopify:section:select', this.onSectionSelect);



      document.addEventListener('shopify:section:deselect', this.onSectionDeselect);



      document.addEventListener('shopify:block:select', this.onBlockSelect);



      document.querySelector('#cart-icon-bubble')?.setAttribute('aria-haspopup', 'dialog');



      // A user can click the header cart icon before this deferred asset has finished

      // loading. header.liquid queues that click instead of navigating to /cart.

      if (window.__sideCartPendingOpen) {

        const pendingTrigger =

          window.__sideCartPendingTrigger instanceof Element

            ? window.__sideCartPendingTrigger

            : document.querySelector('#cart-icon-bubble');



        window.__sideCartPendingOpen = false;

        window.__sideCartPendingTrigger = null;

  

        requestAnimationFrame(() => {

          if (this.isConnected && !this.classList.contains('active')) this.open(pendingTrigger);

        });

      }







      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {



        this._unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {



          if (event?.source === 'side-cart-drawer' || event?.source === 'product-form') return;



          this.refreshAfterExternalUpdate(event?.cartData).catch(() => {});



        });



      }



    }







    disconnectedCallback() {



      if (!this._connected) return;



      this._connected = false;



      this.removeEventListener('click', this.onClick);



      this.removeEventListener('change', this.onChange);



      this.removeEventListener('submit', this.onSubmit);



      document.removeEventListener('click', this.onDocumentClick);



      document.removeEventListener('keydown', this.onDocumentKeydown, true);



      document.removeEventListener('shopify:section:unload', this.onSectionUnload);



      document.removeEventListener('shopify:section:select', this.onSectionSelect);



      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);



      document.removeEventListener('shopify:block:select', this.onBlockSelect);



      this._unsubscribe?.();



      this._unsubscribe = null;



      this.stopBurst();



      this.closeCelebration(false);

    }







    // Dawn product-form.js calls these methods after /cart/add.js.



    getSectionsToRender() {



      return [{ id: this.dataset.sectionId || 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];



    }







    getSectionInnerHTML(html, selector = '.shopify-section') {



      return this.getSectionDOM(html, selector)?.innerHTML || '';



    }







    getSectionDOM(html, selector = '.shopify-section') {



      if (typeof html !== 'string') return null;



      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);



    }







    setActiveElement(element) {



      if (element instanceof Element) this.activeElement = element;



    }







    renderContents(state) {



      this.consumeState(state, { open: true, burst: true, reason: 'add' }).catch((error) => {



        this.showStatus(error.message || this.message('errorMessage', 'Cart updated. Please refresh to see it.'), 'error');



      });



    }







    open(trigger) {



      if (trigger instanceof Element) this.setActiveElement(trigger);



      if (this.classList.contains('active')) return;



      if (!this.activeElement && document.activeElement instanceof Element) this.activeElement = document.activeElement;



      window.clearTimeout(this._closeTimer);

      this.setAttribute('aria-hidden', 'false');



      this.classList.add('animate');



      requestAnimationFrame(() => {



        if (!this.isConnected) return;



        this.classList.add('active');



        requestAnimationFrame(() => {



          if (!this._celebration?.isConnected) this.querySelector('.side-cart__close, .side-cart__panel')?.focus();



        });



      });



      if (this.querySelector('[data-coupon-apply]')) {



        this.getCart().then((cart) => this.syncAppliedCoupons(cart)).catch(() => {});



      }



    }







    close() {



      this.closeCelebration(false);



      if (!this.classList.contains('active')) return;



      this.closeCouponPanel(false, true);



      this.classList.remove('active');



      this.setAttribute('aria-hidden', 'true');

      window.clearTimeout(this._closeTimer);



      this._closeTimer = window.setTimeout(() => {



        if (!this.classList.contains('active')) this.classList.remove('animate');



      }, 400);



      const returnTo = this.activeElement?.isConnected ? this.activeElement : document.querySelector('#cart-icon-bubble');



      returnTo?.focus?.({ preventScroll: true });



      this.activeElement = null;



    }







    onDocumentClick(event) {



      const trigger = event.target instanceof Element && event.target.closest('#cart-icon-bubble, [data-side-cart-open]');



      if (!trigger || this.contains(trigger)) return;



      event.preventDefault();



      if (this.classList.contains('active')) this.close();



      else this.open(trigger);



    }







    onDocumentKeydown(event) {



      if (this._celebration?.isConnected) {



        if (event.key === 'Escape') {



          event.preventDefault();



          this.closeCelebration();



        } else if (event.key === 'Tab') {



          event.preventDefault();



          this._celebration.querySelector('[data-celebration-close]')?.focus();



        }



        return;



      }



      if (!this.classList.contains('active')) {



        const trigger = event.target instanceof Element && event.target.closest('#cart-icon-bubble, [data-side-cart-open]');



        if (trigger && event.code === 'Space') {



          event.preventDefault();



          this.open(trigger);



        }



        return;



      }



      if (event.key === 'Escape') {



        event.preventDefault();



        if (this.isCouponPanelOpen()) this.closeCouponPanel();



        else this.close();



        return;



      }



      if (event.key !== 'Tab') return;



      const scope = this.isCouponPanelOpen() ? this.querySelector('[data-coupon-panel]') : this.querySelector('.side-cart__panel');



      if (!scope) return;



      const focusable = [...scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]



        .filter((element) => !element.closest('[hidden]') && element.getClientRects().length);



      if (!focusable.length) {



        event.preventDefault();



        scope.focus();



        return;



      }



      const first = focusable[0];



      const last = focusable[focusable.length - 1];



      if (event.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) {



        event.preventDefault();



        last.focus();



      } else if (!event.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) {



        event.preventDefault();



        first.focus();



      }



    }







    onClick(event) {



      const target = event.target instanceof Element ? event.target : null;



      if (!target) return;



      const panel = this.querySelector('.side-cart__panel');



      if (this.classList.contains('active') && panel && !panel.contains(target)) {



        event.preventDefault();



        this.close();



        return;



      }



      if (target.closest('[data-coupon-close]')) {



        event.preventDefault();



        this.closeCouponPanel();



        return;



      }



      if (target.closest('[data-side-cart-close]')) {



        event.preventDefault();



        this.close();



        return;



      }



      if (target.closest('[data-coupon-open]')) {



        event.preventDefault();



        this.openCouponPanel();



        return;



      }



      const coupon = target.closest('[data-coupon-apply]');



      if (coupon) {



        event.preventDefault();



        this.applyCoupon(coupon.dataset.couponApply, coupon);



        return;



      }



      const add = target.closest('[data-side-cart-add]');



      if (add) {



        event.preventDefault();



        this.addRecommendation(add);



        return;



      }



      const stepButton = target.closest('[data-quantity-step]');



      if (stepButton) {



        event.preventDefault();



        this.stepQuantity(stepButton);



        return;



      }



      const remove = target.closest('[data-cart-remove]');



      if (remove) {



        event.preventDefault();



        const row = remove.closest('[data-cart-line]');



        if (row) this.changeQuantity(row, 0, remove);



        return;



      }



      const scroll = target.closest('[data-rec-scroll]');



      if (scroll) {



        event.preventDefault();



        const track = this.querySelector('[data-rec-track]');



        track?.scrollBy({ left: Number(scroll.dataset.recScroll || 1) * Math.max(track.clientWidth * 0.8, 220), behavior: 'smooth' });



      }



    }







    onChange(event) {



      const target = event.target;



      if (!(target instanceof Element)) return;



      if (target.matches('[data-cart-quantity]')) {



        const row = target.closest('[data-cart-line]');



        if (row) this.changeQuantity(row, Number(target.value), target);



      } else if (target.matches('[data-cart-variant]')) {



        this.replaceVariant(target);



      } else if (target.matches('[data-side-cart-variant-select]')) {



        this.updateRecommendationVariant(target);



      }



    }







    updateRecommendationVariant(select) {



      const card = select.closest('.side-cart__recommendation-card, [data-recommendation-card]');



      const option = select.selectedOptions?.[0] || select.querySelector('option:checked');



      const price = card?.querySelector('.side-cart__recommendation-price');



      if (!option || !price || !option.dataset.priceDisplay) return;



      const amount = price.querySelector('[data-rec-price]');



      const comparison = price.querySelector('[data-rec-compare-price]');



      if (amount) amount.textContent = option.dataset.priceDisplay;



      else price.textContent = option.dataset.priceDisplay;



      if (comparison) {



        comparison.textContent = option.dataset.compareDisplay || '';



        comparison.hidden = !option.dataset.compareDisplay;



      } else if (option.dataset.compareDisplay) {



        const compare = document.createElement('s');



        compare.textContent = option.dataset.compareDisplay;



        price.append(' ', compare);



      }



      const button = card.querySelector('[data-side-cart-add]');



      if (button) {



        button.dataset.variantId = select.value;



        if (option.dataset.minQuantity) button.dataset.variantMinQuantity = option.dataset.minQuantity;



      }



    }







    onSubmit(event) {



      const form = event.target instanceof Element && event.target.closest('[data-coupon-form]');



      if (!form) return;



      event.preventDefault();



      const code = form.querySelector('[data-coupon-input]')?.value?.trim() || '';



      this.applyCoupon(code, form.querySelector('[type="submit"]'));



    }







    stepQuantity(button) {



      if (this._busy) return;



      const row = button.closest('[data-cart-line]');



      const input = row?.querySelector('[data-cart-quantity]');



      if (!input) return;



      const delta = Number(button.dataset.quantityStep);



      const step = Math.max(1, Number(input.step) || 1);



      const current = Number(input.value);



      const minimum = Math.max(1, Number(input.min) || 1);



      const maximum = input.max ? Number(input.max) : Infinity;



      const next = Math.min(maximum, Math.max(minimum, current + delta * step));



      if (next !== current) this.changeQuantity(row, next, button);



    }







    validQuantity(input, quantity) {



      if (!Number.isInteger(quantity) || quantity < 0) return false;



      if (quantity === 0) return Number(input.min) === 0;



      const minimum = Math.max(1, Number(input.min) || 1);



      const maximum = input.max ? Number(input.max) : Infinity;



      const step = Math.max(1, Number(input.step) || 1);



      return quantity >= minimum && quantity <= maximum && (quantity - minimum) % step === 0;



    }







    async changeQuantity(row, quantity, trigger) {



      if (this._busy) return;



      const input = row.querySelector('[data-cart-quantity]');



      const line = Number(row.dataset.cartLine || input?.dataset.index);



      const previous = Number(input?.getAttribute('value') || 0);



      if (!Number.isInteger(line) || line < 1 || (!input && quantity !== 0)) return;



      const removing = quantity === 0 && trigger?.matches?.('[data-cart-remove]');



      if (input && !removing && !this.validQuantity(input, quantity)) {



        input.value = String(previous);



        this.showStatus('Choose a valid quantity.', 'error');



        return;



      }



      if (quantity === previous && !(quantity === 0 && !input)) return;



      const release = this.lock(trigger);



      if (!release) return;



      try {



        const state = await this.post(cartRoute('change'), {



          line,



          quantity,



          ...this.sectionPayload(),



        });



        await this.consumeState(state, {



          burst: quantity > previous,



          reason: 'quantity',



          message: this.message('updatedMessage', 'Cart updated.'),



          focus: quantity > 0 ? { line, type: trigger?.dataset?.quantityStep ? 'step' : 'input', step: trigger?.dataset?.quantityStep } : null,



        });



        this.publishCartUpdate(state);



      } catch (error) {



        if (input) input.value = String(previous);



        this.showStatus(error.message || this.message('errorMessage', 'Could not update your cart.'), 'error');



      } finally {



        release();



      }



    }







    async addRecommendation(button) {



      if (this._busy) return;



      const card = button.closest('.side-cart__recommendation-card, [data-recommendation-card], article');



      const selector = card?.querySelector('[data-side-cart-variant-select]');



      const selected = selector?.selectedOptions?.[0];



      const id = Number(selector?.value || button.dataset.variantId);



      const quantity = Number(selected?.dataset.minQuantity || button.dataset.variantMinQuantity || 1);



      if (!Number.isSafeInteger(id) || id < 1) return;



      if (!Number.isSafeInteger(quantity) || quantity < 1) {



        this.showStatus(this.message('errorMessage', 'This product cannot be added right now.'), 'error');



        return;



      }



      const release = this.lock(button);



      if (!release) return;



      try {



        const state = await this.post(cartRoute('add'), {



          items: [{ id, quantity }],



          ...this.sectionPayload(),



        });



        await this.consumeState(state, {



          burst: true,



          reason: 'add',



          message: this.message('addedMessage', 'Added to your cart.'),



        });



        this.publishCartUpdate(state);



      } catch (error) {



        this.showStatus(error.message || this.message('errorMessage', 'Could not add this product.'), 'error');



      } finally {



        release();



      }



    }







    async replaceVariant(select) {



      if (this._busy) return;



      const row = select.closest('[data-cart-line]');



      const selectedId = Number(select.value);



      const originalId = Number(row?.dataset.currentVariantId || select.dataset.currentVariantId || select.querySelector('option[selected]')?.value);



      const oldKey = row?.dataset.lineKey || select.dataset.lineKey;



      const quantity = Number(row?.querySelector('[data-cart-quantity]')?.value || select.dataset.lineQuantity || 1);



      if (!row || !oldKey || !Number.isSafeInteger(selectedId) || selectedId < 1 || !Number.isSafeInteger(quantity) || quantity < 1) return;



      if (selectedId === originalId) return;



      const release = this.lock(select);



      if (!release) return;



      const beforeSnapshot = this.cartSnapshot();



      let added = false;



      let baseline = 0;



      try {



        const before = await this.getCart();



        baseline = this.simpleVariantLine(before, selectedId)?.quantity || 0;



        await this.post(cartRoute('add'), { items: [{ id: selectedId, quantity }] });



        added = true;



        let state;



        try {



          state = await this.post(cartRoute('change'), { id: oldKey, quantity: 0, ...this.sectionPayload() });



        } catch (firstError) {



          const current = await this.getCart();



          const oldLine = current.items?.find((item) => item.key === oldKey) || this.simpleVariantLine(current, originalId);



          if (!oldLine) {



            if (!await this.refreshSections()) throw firstError;



            const unlocked = this.newlyUnlockedRewards(beforeSnapshot, this.cartSnapshot());



            if (unlocked.length) this.showRewardCelebration(unlocked);



            this.burst('add');



            this.showStatus(this.message('updatedMessage', 'Cart updated.'), 'success');



            this.publishCartUpdate(current);



            return;



          }



          try {



            state = await this.post(cartRoute('change'), { id: oldLine.key, quantity: 0, ...this.sectionPayload() });



          } catch (secondError) {



            throw secondError;



          }



        }



        await this.consumeState(state, {



          burst: true,



          reason: 'add',



          message: this.message('updatedMessage', 'Cart updated.'),



        });



        this.publishCartUpdate(state);



      } catch (error) {



        if (added) {



          // If the removal was uncertain, inspect the server before compensating.



          try {



            const current = await this.getCart();



            const oldStillPresent = current.items?.some((item) => item.key === oldKey) || Boolean(this.simpleVariantLine(current, originalId));



            if (!oldStillPresent) {



              const refreshed = await this.refreshSections();



              if (refreshed) {



                const unlocked = this.newlyUnlockedRewards(beforeSnapshot, this.cartSnapshot());



                if (unlocked.length) this.showRewardCelebration(unlocked);



                this.burst('add');



                this.showStatus(this.message('updatedMessage', 'Cart updated.'), 'success');



                this.publishCartUpdate(current);



                return;



              }



            } else {



              await this.restoreVariant(selectedId, baseline);



              await this.refreshSections();



            }



          } catch (_) {



            // The cart page remains the reliable recovery route if the network is down.



          }



        }



        if (select.isConnected && originalId) select.value = String(originalId);



        this.showStatus(error.message || this.message('errorMessage', 'Could not change this variant.'), 'error');



      } finally {



        release();



      }



    }







    simpleVariantLine(cart, variantId) {



      return cart?.items?.find((item) =>



        Number(item.variant_id || item.id) === Number(variantId) &&



        (!item.properties || Object.keys(item.properties).length === 0) &&



        !item.selling_plan_allocation



      );



    }







    async restoreVariant(variantId, baseline) {



      const current = await this.getCart();



      const addedLine = this.simpleVariantLine(current, variantId);



      if (addedLine && addedLine.quantity > baseline) {



        await this.post(cartRoute('change'), { id: addedLine.key, quantity: baseline, ...this.sectionPayload() });



      }



    }







    async applyCoupon(rawCode, trigger) {



      if (this._busy) return;



      const code = String(rawCode || '').trim();



      if (!code) {



        this.showStatus('Enter a coupon code.', 'error');



        this.querySelector('[data-coupon-input]')?.focus();



        return;



      }



      const release = this.lock(trigger);



      if (!release) return;



      try {



        const cart = await this.getCart();



        const existing = Array.isArray(cart.discount_codes)



          ? cart.discount_codes.filter((discount) => discount.applicable !== false).map((discount) => discount.code).filter(Boolean)



          : [...this.querySelectorAll('[data-applied-code]')].map((element) => element.dataset.appliedCode).filter(Boolean);



        if (existing.some((old) => sameCode(old, code))) {



          this.showStatus('This coupon is already in your cart.', 'success');



          return;



        }



        const state = await this.post(cartRoute('update'), {



          discount: [...existing, code].join(','),



          ...this.sectionPayload(),



        });



        const result = Array.isArray(state.discount_codes)



          ? state.discount_codes.find((discount) => sameCode(discount.code, code))



          : null;



        if (result?.applicable === false) {



          // Shopify can retain rejected codes in the cart; restore the original set.



          try {



            const restored = await this.post(cartRoute('update'), { discount: existing.join(','), ...this.sectionPayload() });



            await this.consumeState(restored);



          } catch (_) {



            await this.refreshSections().catch(() => {});



          }



          this.showStatus('This coupon is not eligible for the current cart.', 'error');



          return;



        }



        const observableDiscount = this.discountWasApplied(cart, state, code, result);



        await this.consumeState(state, {



          burst: Boolean(observableDiscount),



          reason: 'coupon',



          message: observableDiscount



            ? this.message('couponSuccessMessage', 'Coupon applied.')



            : this.message('couponPendingMessage', 'Coupon submitted. Eligibility is confirmed at checkout.'),



        });



        if (observableDiscount) this.markCouponApplied(code);



        this.publishCartUpdate(state);



      } catch (error) {



        this.showStatus(error.message || this.message('errorMessage', 'Could not apply this coupon.'), 'error');



      } finally {



        release();



      }



    }







    discountWasApplied(before, after, code, result) {



      if (result?.applicable === true) return true;



      if (after.cart_level_discount_applications?.some((discount) => sameCode(discount.title, code))) return true;



      if (after.discount_applications?.some((discount) => sameCode(discount.title || discount.code, code))) return true;



      if (after.items?.some((item) => item.line_level_discount_allocations?.some((allocation) =>



        sameCode(allocation.discount_application?.title || allocation.discount_application?.code, code)))) return true;



      const beforeDiscount = Number(before.total_discount ?? before.total_discounts);



      const afterDiscount = Number(after.total_discount ?? after.total_discounts);



      if (Number.isFinite(beforeDiscount) && Number.isFinite(afterDiscount) && afterDiscount > beforeDiscount) return true;



      const beforeTotal = Number(before.total_price);



      const afterTotal = Number(after.total_price);



      return Number.isFinite(beforeTotal) && Number.isFinite(afterTotal) && afterTotal < beforeTotal;



    }







    async post(url, payload) {



      const response = await fetch(url, {



        method: 'POST',



        credentials: 'same-origin',



        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },



        body: JSON.stringify(payload),



      });



      const state = await response.json().catch(() => ({}));



      if (!response.ok || state.errors || Number(state.status) >= 400) {



        const detail = state.description || state.message || (typeof state.errors === 'string' ? state.errors : null);



        throw new Error(detail || this.message('errorMessage', 'Something went wrong. Please try again.'));



      }



      return state;



    }







    async getCart() {



      const response = await fetch(cartJsonRoute(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });



      if (!response.ok) throw new Error(this.message('errorMessage', 'Could not load the cart.'));



      return response.json();



    }







    sectionPayload() {



      return {



        sections: this.getSectionsToRender().map((section) => section.id),



        sections_url: `${window.location.pathname}${window.location.search}`,



      };



    }







    async consumeState(state, options = {}) {



      const wasOpen = this.classList.contains('active');



      const before = this.cartSnapshot();



      const scroller = this.querySelector('.side-cart__scroll');



      const track = this.querySelector('[data-rec-track]');



      const scrollTop = scroller?.scrollTop || 0;



      const trackLeft = track?.scrollLeft || 0;



      let rendered = this.renderSections(state?.sections, state?.item_count);



      if (!rendered) rendered = await this.refreshSections();



      if (!rendered) throw new Error('Cart changed, but the drawer could not refresh. Please reload the page.');



      const unlocked = this.newlyUnlockedRewards(before, this.cartSnapshot());



      if (wasOpen) {



        this.querySelector('.side-cart__scroll')?.scrollTo({ top: scrollTop });



        this.querySelector('[data-rec-track]')?.scrollTo({ left: trackLeft });



        if (!this.contains(document.activeElement)) this.querySelector('.side-cart__close')?.focus({ preventScroll: true });



      }



      if (options.open) this.open();



      if (options.focus && this.classList.contains('active')) this.restoreLineFocus(options.focus);



      this.syncAppliedCoupons(state);



      if (options.message) this.showStatus(options.message, 'success');



      if (unlocked.length) this.showRewardCelebration(unlocked);



      if (options.burst || unlocked.length) this.burst(options.reason);



    }







    cartSnapshot() {



      const source = this.querySelector('[data-side-cart-rewards]');



      if (!source) return { subtotal: NaN, count: NaN, tiers: [] };



      return {



        subtotal: Number(source.dataset.cartSubtotal),



        count: Number(source.dataset.cartCount),



        tiers: [...source.querySelectorAll('[data-reward-threshold]')]



          .map((tier) => ({ threshold: Number(tier.dataset.rewardThreshold), label: tier.dataset.rewardLabel?.trim() || '' }))



          .filter((tier) => Number.isFinite(tier.threshold) && tier.threshold > 0),



      };



    }







    newlyUnlockedRewards(before, after) {



      if (!Number.isFinite(before.subtotal) || !Number.isFinite(after.subtotal) || after.subtotal <= before.subtotal) return [];



      return after.tiers



        .filter((tier) => tier.threshold > before.subtotal && tier.threshold <= after.subtotal)



        .sort((a, b) => a.threshold - b.threshold)



        .map((tier) => tier.label || 'A new cart reward');



    }







    async refreshAfterExternalUpdate(state) {



      const before = this.cartSnapshot();



      if (!await this.refreshSections()) return;



      const after = this.cartSnapshot();



      this.syncAppliedCoupons(state);



      const unlocked = this.newlyUnlockedRewards(before, after);



      if (unlocked.length) this.showRewardCelebration(unlocked);



      if ((Number.isFinite(before.count) && Number.isFinite(after.count) && after.count > before.count) || unlocked.length) {



        this.burst('add');



      }



    }







    renderSections(sections, itemCount) {



      if (!sections || typeof sections !== 'object') return false;



      const id = this.dataset.sectionId || 'cart-drawer';



      const html = sections[id];



      if (typeof html !== 'string' || !html.trim()) return false;



      const parsed = new DOMParser().parseFromString(html, 'text/html');



      const sourceRoot = parsed.querySelector('cart-drawer[data-side-cart-root]');



      const source = sourceRoot?.querySelector('#CartDrawer') || parsed.querySelector('#CartDrawer');



      const target = this.querySelector('#CartDrawer');



      if (!source || !target) return false;



      const couponWasOpen = this.isCouponPanelOpen();



      target.innerHTML = source.innerHTML;



      if (sourceRoot) {



        ['burstEnabled', 'burstCount', 'burstColors', 'rewardPopupTitle', 'rewardPopupSubtitle', 'couponAppliedLabel', 'addedMessage', 'updatedMessage', 'couponSuccessMessage', 'couponPendingMessage', 'errorMessage'].forEach((name) => {



          if (Object.prototype.hasOwnProperty.call(sourceRoot.dataset, name)) this.dataset[name] = sourceRoot.dataset[name];



        });



      }



      this.syncAppliedCoupons();



      this.classList.toggle('is-empty', Number.isFinite(Number(itemCount)) ? Number(itemCount) === 0 : sourceRoot?.classList.contains('is-empty'));



      if (couponWasOpen) {



        const panel = this.querySelector('[data-coupon-panel]');



        if (panel) {



          panel.hidden = false;



          panel.setAttribute('aria-hidden', 'false');



          panel.classList.add('is-open');



          panel.querySelector('[data-coupon-close]')?.focus({ preventScroll: true });



        }



      }



      const iconHtml = sections['cart-icon-bubble'];



      const icon = document.querySelector('#cart-icon-bubble');



      if (icon && typeof iconHtml === 'string') {



        const iconSource = this.getSectionDOM(iconHtml, '.shopify-section');



        if (iconSource) icon.innerHTML = iconSource.innerHTML;



        icon.setAttribute('aria-haspopup', 'dialog');



      }



      return true;



    }







    async refreshSections() {



      const ids = this.getSectionsToRender().map((section) => section.id);



      const url = new URL(window.location.href);



      url.searchParams.set('sections', ids.join(','));



      const response = await fetch(`${url.pathname}${url.search}`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });



      if (!response.ok) return false;



      const sections = await response.json();



      return this.renderSections(sections);



    }







    restoreLineFocus(focus) {



      const row = this.querySelector(`[data-cart-line="${Number(focus.line)}"]`);



      const target = focus.type === 'step'



        ? row?.querySelector(`[data-quantity-step="${focus.step === '-1' ? '-1' : '1'}"]`)



        : row?.querySelector('[data-cart-quantity]');



      (target || this.querySelector('.side-cart__close'))?.focus({ preventScroll: true });



    }







    publishCartUpdate(state) {



      if (typeof window.publish !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return;



      try {



        Promise.resolve(window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'side-cart-drawer', cartData: state })).catch(() => {});



      } catch (_) { /* Third-party subscribers must not break the drawer. */ }



    }







    lock(trigger) {



      if (this._busy) return null;



      this._busy = true;



      this.setAttribute('aria-busy', 'true');



      const controls = [...this.querySelectorAll('[data-side-cart-add], [data-cart-remove], [data-quantity-step], [data-cart-quantity], [data-cart-variant], [data-side-cart-variant-select], [data-coupon-apply], [data-coupon-form] button')]



        .map((element) => ({ element, disabled: element.disabled }));



      controls.forEach(({ element }) => { element.disabled = true; });



      trigger?.classList?.add('is-loading');



      return () => {



        this._busy = false;



        this.removeAttribute('aria-busy');



        controls.forEach(({ element, disabled }) => { if (element.isConnected) element.disabled = disabled; });



        trigger?.classList?.remove('is-loading');



      };



    }







    message(attribute, fallback) {



      return this.dataset[attribute]?.trim() || fallback;



    }







    syncAppliedCoupons(cart) {



      const codes = Array.isArray(cart?.discount_codes)



        ? cart.discount_codes.filter((discount) => discount?.applicable === true && discount.code).map((discount) => String(discount.code))



        : [];



      this.querySelectorAll('[data-applied-code]').forEach((element) => {



        const code = element.dataset.appliedCode?.trim();



        if (code && !codes.some((existing) => sameCode(existing, code))) codes.push(code);



      });



      this._appliedCodes = codes;



      this.querySelectorAll('[data-coupon-apply]').forEach((button) => {



        if (!button.dataset.couponApplyLabel) button.dataset.couponApplyLabel = button.textContent.trim();



        const applied = this._appliedCodes.some((code) => sameCode(code, button.dataset.couponApply));



        button.textContent = applied ? this.message('couponAppliedLabel', 'Applied') : button.dataset.couponApplyLabel;



        button.disabled = applied;



        button.classList.toggle('is-applied', applied);



        button.closest('.side-cart__coupon-option, .side-cart__coupon-preview')?.classList.toggle('is-applied', applied);



      });



    }







    markCouponApplied(code) {



      const codes = [...(this._appliedCodes || [])];



      if (!codes.some((existing) => sameCode(existing, code))) codes.push(code);



      this.syncAppliedCoupons({ discount_codes: codes.map((value) => ({ code: value, applicable: true })) });



    }







    showStatus(message, type = 'success') {



      const status = this.querySelector('[data-side-cart-status]');



      if (!status) return;



      window.clearTimeout(this._statusTimer);



      status.textContent = String(message);



      status.dataset.status = type;



      status.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');



      status.hidden = false;



      status.classList.add('is-visible');



      this._statusTimer = window.setTimeout(() => {



        status.classList.remove('is-visible');



        window.setTimeout(() => { if (status.isConnected) status.hidden = true; }, 220);



      }, 4000);



    }







    openCouponPanel() {



      const panel = this.querySelector('[data-coupon-panel]');



      if (!panel) return;



      if (this.isCouponPanelOpen()) return;



      window.clearTimeout(this._couponTimer);



      this._couponReturnFocus = document.activeElement;



      panel.hidden = false;



      panel.setAttribute('aria-hidden', 'false');



      requestAnimationFrame(() => {



        panel.classList.add('is-open');



        panel.querySelector('[data-coupon-close]')?.focus({ preventScroll: true });



      });



    }







    closeCouponPanel(restoreFocus = true, immediate = false) {



      const panel = this.querySelector('[data-coupon-panel]');



      if (!panel || panel.hidden) return;



      window.clearTimeout(this._couponTimer);



      panel.classList.remove('is-open');



      panel.setAttribute('aria-hidden', 'true');



      const finish = () => {



        panel.hidden = true;



        if (restoreFocus) {



          const target = this._couponReturnFocus?.isConnected ? this._couponReturnFocus : this.querySelector('[data-coupon-open]');



          target?.focus?.({ preventScroll: true });



        }



      };



      if (immediate) finish();



      else this._couponTimer = window.setTimeout(finish, 220);



    }







    isCouponPanelOpen() {



      const panel = this.querySelector('[data-coupon-panel]');



      return Boolean(panel && !panel.hidden && panel.getAttribute('aria-hidden') !== 'true');



    }







    showRewardCelebration(labels) {



      if (!labels?.length) return;



      this.closeCelebration(false);



      const overlay = document.createElement('div');



      overlay.className = 'side-cart__celebration';



      overlay.dataset.sideCartCelebration = '';



      overlay.setAttribute('role', 'dialog');



      overlay.setAttribute('aria-modal', 'true');



      overlay.setAttribute('aria-labelledby', 'SideCartCelebrationTitle');



      overlay.style.setProperty(



        '--scd-reward-heading-weight',



        window.getComputedStyle?.(this)?.getPropertyValue('--scd-reward-heading-weight')?.trim() || '500',



      );



      const drawerStyle = window.getComputedStyle?.(this);



      overlay.style.setProperty(

        '--scd-celebration-title-size',

        drawerStyle?.getPropertyValue('--scd-celebration-title-size')?.trim() || '28px',

      );



      overlay.style.setProperty(

        '--scd-celebration-text-size',

        drawerStyle?.getPropertyValue('--scd-celebration-text-size')?.trim() || '15px',

      );



      overlay.style.setProperty(

        '--scd-small-text-size',

        drawerStyle?.getPropertyValue('--scd-small-text-size')?.trim() || '10px',

      );



      overlay.innerHTML = `



        <div class="side-cart__celebration-backdrop" data-celebration-close></div>



        <div class="side-cart__celebration-card">



          <button type="button" class="side-cart__celebration-close" data-celebration-close aria-label="Close reward message">×</button>



          <span class="side-cart__celebration-sparkle" aria-hidden="true">✦</span>



          <p class="side-cart__celebration-eyebrow"></p>



          <h2 class="side-cart__celebration-title" id="SideCartCelebrationTitle"></h2>



          <p class="side-cart__celebration-reward"></p>



        </div>`;



      overlay.querySelector('.side-cart__celebration-eyebrow').textContent = this.message('rewardPopupSubtitle', 'Just for you');



      overlay.querySelector('.side-cart__celebration-title').textContent = this.message('rewardPopupTitle', 'Reward unlocked!');



      overlay.querySelector('.side-cart__celebration-reward').textContent = labels.join(' · ');



      overlay.addEventListener('click', (event) => {



        if (event.target instanceof Element && event.target.closest('[data-celebration-close]')) this.closeCelebration();



      });



      this._rewardReturnFocus = document.activeElement instanceof Element ? document.activeElement : null;



      document.body.appendChild(overlay);



      this._celebration = overlay;



      requestAnimationFrame(() => {



        if (overlay.isConnected) {



          overlay.classList.add('is-visible');



          overlay.querySelector('.side-cart__celebration-close')?.focus({ preventScroll: true });



        }



      });



    }







    closeCelebration(restoreFocus = true) {



      if (!this._celebration) return;



      this._celebration.remove();



      this._celebration = null;



      if (restoreFocus) {



        const target = this._rewardReturnFocus?.isConnected ? this._rewardReturnFocus : this.querySelector('.side-cart__close');



        target?.focus?.({ preventScroll: true });



      }



      this._rewardReturnFocus = null;



    }







    burst() {



      if (this.dataset.burstEnabled === 'false' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;



      this.stopBurst();



      const panel = this.querySelector('.side-cart__panel');



      if (!panel) return;



      const bounds = panel.getBoundingClientRect();



      const width = Math.round(panel.clientWidth || bounds.width);



      const height = Math.round(panel.clientHeight || bounds.height);



      if (width < 1 || height < 1) return;



      const canvas = document.createElement('canvas');



      canvas.className = 'side-cart__burst-canvas';



      canvas.setAttribute('aria-hidden', 'true');



      // Keep the animation inside the drawer, including when its width is edited.



      // Inline priority protects the panel bounds from broad theme canvas rules.



      [



        ['position', 'absolute'], ['inset', '0'], ['display', 'block'],



        ['width', '100%'], ['height', '100%'], ['max-width', 'none'], ['max-height', 'none'],



        ['pointer-events', 'none'], ['z-index', '9'],



      ].forEach(([name, value]) => canvas.style.setProperty(name, value, 'important'));



      panel.appendChild(canvas);



      this._burstCanvas = canvas;



      const ratio = Math.min(window.devicePixelRatio || 1, 2);



      canvas.width = Math.round(width * ratio);



      canvas.height = Math.round(height * ratio);



      const context = canvas.getContext('2d');



      if (!context) { this.stopBurst(); return; }



      context.scale(ratio, ratio);



      const configuredColors = (this.dataset.burstColors || '').split(',').map((color) => color.trim()).filter(Boolean);



      const colors = configuredColors.length ? configuredColors : ['#3555a6', '#0ba592', '#ffbe53', '#f16b6b'];



      const count = Math.min(160, Math.max(36, Number(this.dataset.burstCount) || 72));



      const particles = Array.from({ length: count }, (_, index) => {



        // Two small cannons fire toward the middle. Air resistance lets each



        // strip reach its apex quickly, then flutter down instead of streaming up.



        const fromLeft = index % 2 === 0;



        const apexTime = 0.55 + Math.random() * 0.34;



        const rise = height * (0.36 + Math.random() * 0.42);



        const riseGravity = 2 * rise / (apexTime * apexTime);



        return {



          x: width * (fromLeft ? 0.16 : 0.84) + (Math.random() - 0.5) * width * 0.08,



          y: height - 6 - Math.random() * Math.min(20, height * 0.03),



          vx: width * (0.28 + Math.random() * 0.5) * (fromLeft ? 1 : -1),



          vy: -riseGravity * apexTime,



          riseGravity,



          apexTime,



          fallSpeed: height * (0.35 + Math.random() * 0.27),



          delay: (index % 4) * 0.018,



          sway: 2 + Math.random() * Math.min(9, width * 0.035),



          swayRate: 6 + Math.random() * 4,



          phase: Math.random() * Math.PI * 2,



          spin: (Math.random() - 0.5) * 18,



          angle: Math.random() * Math.PI,



          width: 2.5 + Math.random() * 3,



          length: 7 + Math.random() * 9,



          color: colors[index % colors.length],



        };



      });



      const duration = 2800;



      const start = performance.now();



      const draw = (now) => {



        const elapsed = now - start;



        const time = elapsed / 1000;



        const progress = Math.min(1, elapsed / duration);



        context.clearRect(0, 0, width, height);



        particles.forEach((particle) => {



          const age = time - particle.delay;



          if (age < 0 || progress >= 1) return;



          const drag = 1.8;



          const x = particle.x + particle.vx * (1 - Math.exp(-drag * age)) / drag



            + particle.sway * Math.sin(age * particle.swayRate + particle.phase) * Math.min(1, age * 2);



          const fallTime = Math.max(0, age - particle.apexTime);



          const y = fallTime === 0



            ? particle.y + particle.vy * age + 0.5 * particle.riseGravity * age * age



            : particle.y + particle.vy * particle.apexTime



              + 0.5 * particle.riseGravity * particle.apexTime * particle.apexTime



              + particle.fallSpeed * (fallTime - (1 - Math.exp(-2.4 * fallTime)) / 2.4);



          if (x < -particle.length || x > width + particle.length || y < -particle.length || y > height + particle.length) return;



          context.globalAlpha = Math.min(1, (duration / 1000 - age) / 0.55);



          context.save();



          context.translate(x, y);



          context.rotate(particle.angle + particle.spin * age);



          context.fillStyle = particle.color;



          context.fillRect(-particle.width / 2, -particle.length / 2, particle.width, particle.length);



          context.restore();



        });



        context.globalAlpha = 1;



        if (progress < 1 && this._burstCanvas === canvas) this._burstFrame = requestAnimationFrame(draw);



        else this.stopBurst();



      };



      this._burstFrame = requestAnimationFrame(draw);



    }







    stopBurst() {



      if (this._burstFrame) cancelAnimationFrame(this._burstFrame);



      this._burstFrame = null;



      this._burstCanvas?.remove();



      this._burstCanvas = null;



    }







    sectionEventMatches(event) {



      const id = this.dataset.sectionId;



      return Boolean(id && (event.detail?.sectionId === id || event.target?.id === `shopify-section-${id}`));



    }







    onSectionUnload(event) {



      if (this.sectionEventMatches(event)) this.remove();



    }







    onSectionSelect(event) {



      if (this.sectionEventMatches(event)) this.open();



    }







    onSectionDeselect(event) {



      if (this.sectionEventMatches(event)) this.close();



    }







    onBlockSelect(event) {



      if (!this.contains(event.target)) return;



      this.open();



      if (event.target.closest('[data-coupon-panel]')) this.openCouponPanel();



    }



  }







  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', SideCartDrawer);



})();
